import { FC } from 'react';
import Link from 'next/link';
import styles from './RelativeBook.module.scss';

interface IRelativeBook {
  alias: string;
  currentBookType: string;
}

const RelativeBook: FC<IRelativeBook> = ({ alias, currentBookType }) => {
  return (
    <div className={styles.relativeButtons}>
      {currentBookType === 'audio_book' ? (
        <>
          <Link prefetch={false} href={alias} className={styles.relativeButtons__item}>
            Текст
          </Link>
          <div className={`${styles.relativeButtons__item} ${styles.relativeButtons__item_audio} ${styles.relativeButtons__item_active} ${styles.relativeButtons__item_activeAudio}`}>Аудио</div>
        </>
      ) : (
        <>
          <div className={`${styles.relativeButtons__item} ${styles.relativeButtons__item_book} ${styles.relativeButtons__item_active} ${styles.relativeButtons__item_activeText}`}>Текст</div>
          <Link prefetch={false} href={alias} className={`${styles.relativeButtons__item} ${styles.relativeButtons__item_audio}`}>
            Aудио
          </Link>
        </>
      )}
    </div>
  );
};
export default RelativeBook;
